const baseClass = '.js-language-switch';
const languageSwitches = document.querySelectorAll(baseClass);

let selectedLanguageId = '';
let selectedLanguageUrl = '';

const setSelectedLanguage = (id, url) => {
  if (id.endsWith('-footer')) {
    selectedLanguageId = id.slice(0, -7);
  }
  else {
    selectedLanguageId = id;
  }
  selectedLanguageUrl = url;
};

const onUpdateLanguage = () => {
  if (selectedLanguageId === document.documentElement.lang) {
    // No change, but reload anyway to give the user the impression their choice is confirmed.
    window.location.reload();
  }
  else {
    const alt = document.querySelector(`link[rel=alternate][hreflang='${selectedLanguageId}']`);
    if (alt) {
      // If an alternate link is found, use that.
      window.location.href = alt.href;
    }
    else {
      // Otherwise just go to the homepage in the selected language.
      window.location.href = selectedLanguageUrl;
    }
  }
};

const onLanguageChange = (event) => {
  setSelectedLanguage(event.target.id, event.target.value);
};

const init = languageSwitch => {
  const radios = languageSwitch.querySelectorAll(`${baseClass}-radio`);
  const button = languageSwitch.querySelector(`${baseClass}-button`);

  radios.forEach((radio) => {
    if (radio.checked) {
      setSelectedLanguage(radio.id, radio.value);
    }

    radio.addEventListener('change', onLanguageChange);
  });

  button.addEventListener('click', onUpdateLanguage);
};

languageSwitches.forEach(init);
